<div class="page-loader">
  <ion-spinner
    name="crescent"
    [ngClass]="{'animated fadeIn': (!isCordova && isDesktop)}"></ion-spinner>
</div>
